import React, { useState } from "react";
import GoogleLogin from "./socialOauth/google/googleLogin";
import FBLogin from "./socialOauth/facebook/fbLogin";

import "../authentication/socialOauth/socialOauth.css";

const SocialLogin = () => {

  const [authError, setAuthError] = useState(false);
  const [authErrorMsg, setAuthErrorMsg] = useState("");

  return (
    <>
      <div className="text-center social-auth-container">
        <GoogleLogin setAuthError={setAuthError} setAuthErrorMsg={setAuthErrorMsg} />
        {/* <FBLogin setAuthError={setAuthError} setAuthErrorMsg={setAuthErrorMsg} /> */}
        {authError &&
          <div className={'alert alert-danger mt-3'}>{authErrorMsg}</div>
        }
      </div>
    </>
  );
};

export default SocialLogin;